import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/permissions/`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/permissions.js